import config from 'config';
import fetchWithToken from './provider/fetch';

const scimMeEndPoint = (): string => `${config.EXT_ADMIN_SERVICE_URL}`;

export const daoMeGet = (): Promise<object> =>
  fetchWithToken({ reqUrl: `${scimMeEndPoint()}/me`, method: 'GET', body: null, isTenant: false });

export default {
  daoMeGet,
};
